import { render, staticRenderFns } from "./project-item.vue?vue&type=template&id=b5bc8e64&scoped=true&"
import script from "./project-item.vue?vue&type=script&lang=js&"
export * from "./project-item.vue?vue&type=script&lang=js&"
import style0 from "./project-item.vue?vue&type=style&index=0&id=b5bc8e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bc8e64",
  null
  
)

export default component.exports